import React, {Component} from 'react';
import {
    show_popup,
    close_popup,
    AJAX,
    showPreloader,
    hidePreloader, addStepLog, censorJSON, safeStringify, setUrlSinglePageApp
} from "../functions";
import {Redirect} from "react-router-dom";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import WrapperContentFromArticleForPopup from "../common/WrapperContentFromArticleForPopup";
import {withRouter} from "react-router";
class ReminderPopup extends Component {
	constructor(props) {
		super(props);
		this.reloadPage = this.reloadPage.bind(this);
		this.proceed = this.proceed.bind(this);
		this.handleSetPage = this.handleSetPage.bind(this);
		this.handleSetPage({name: 'thank_you', params: false});
		this.state = {};
	}

	handleSetPage(options) {
		this.props.handleSetPage(options);
	}
	
	reloadPage() {
		this.props.reloadPage();
	}

	proceed() {
		close_popup();
		this.reloadPage();
	}

	render() {
	    return (
			<div className="row">
				<div className="col-12 text-center">
					<div className="row m-3">
						<div className="col-12 text-center gray">
							If accident was selected Yes... please remind hirer to submit accident form.
						</div>
					</div>
					<div className="row mx-3">
						<div className="col-12 text-center">
							<button type="button" className="base-input mb-4 green" onClick={this.proceed}>
								PROCEED
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const pharagraphs = {
    'unlock': {
        1: <><p>Thank you, your vehicle is unlocked. If it was unsuccessful, please try again or click the “Need Help?” icon to call for assistance.</p><div className="lizard-with-thumb-up mx-auto" /></>,
        2: <><div className="no_smoking_img mx-auto my-3" /><p>This vehicle is NON-SMOKING. Smoking in this vehicle will incur an automatic cleaning fee plus administration cost being deducted from your security deposit.</p></>,
        3: <><p>Other important information can be found on the windscreen sticker including the FUEL TYPE and HEIGHT of the vehicle. Please make sure you have the correct fuel type before refuelling.</p></>,
        4: <>
            <p>Please observe Height Restrictions in Carparks and other overhead obstructions whilst driving.
                <br/><br/>
                Enjoy your ride!
            </p>
            <div className="small-lizard-with-thumb-up mx-auto mt-1 mb-2"/>
        </>,
    },
    'lock': {
        1: <>Thank you, the vehicle is now locked and the engine is immobilised. Your hire is now completed.
            <br/>
            The pre-authorisation fee held against your credit/debit card will be released back to your bank account within 10 working days – less any additional fees or charges (where applicable).
            <br/>
            <span className="small-text" style={{fontWeight: 800}}>
                Find out more about banks handle Pre-Auth transactions?
                <br/>
                Click <a target="_blank" className="blue-link" href="https://go.eway.io/s/article/How-do-banks-handle-pre-auth-transactions">here</a>
            </span>
        </>,
        2: <><p>Additional costs which may have been incurred during your hire such as additional KM travelled, tolls, traffic infringements, damage, cleaning fees etc will be deducted from your security deposit prior to its return.</p></>,
    }
};

class ShowPopup extends Component {
    constructor(props) {
        super(props);
        let pharagraphs = {
            'unlock': [
                <><p>Thank you, your vehicle is unlocked. If it was unsuccessful, please try again or click the “Need
                    Help?” icon to call for assistance.</p>
                    <div className="lizard-with-thumb-up mx-auto"/>
                </>,
                <>
                    <div className="no_smoking_img mx-auto my-3"/>
                    <p>This vehicle is NON-SMOKING. Smoking in this vehicle will incur an automatic cleaning fee plus
                        administration cost being deducted from your security deposit.</p>
                </>,
                <><p>Other important information can be found on the windscreen sticker including the FUEL TYPE and
                    HEIGHT of the vehicle. Please make sure you have the correct fuel type before refuelling.</p>
                </>,
                <>
                    <p>Please observe Height Restrictions in Carparks and other overhead obstructions whilst driving.
                        <br/><br/>
                        Enjoy your ride!
                    </p>
                    <div className="small-lizard-with-thumb-up mx-auto mt-1 mb-2"/>
                </>,
            ],
            'lock': [
                <>Thank you, the vehicle is now locked and the engine is immobilised. Your hire is now completed.
                    <br/>
                    The pre-authorisation fee held against your credit/debit card will be released back to your bank
                    account within 10 working days – less any additional fees or charges (where applicable).
                    <br/>
                    <span className="small-text" style={{fontWeight: 800}}>
                        Find out more about banks handle Pre-Auth transactions?
                        <br/>
                        Click <a target="_blank" className="blue-link"
                                 href="https://go.eway.io/s/article/How-do-banks-handle-pre-auth-transactions">here</a>
                    </span>
                </>,
                <><p>Additional costs which may have been incurred during your hire such as additional KM travelled,
                    tolls, traffic infringements, damage, cleaning fees etc will be deducted from your security deposit
                    prior to its return.</p>
                </>,
            ],
        };

        if (this.props.global_operation === 'unlock'
            && typeof this.props.unlock_note === 'string'
            && this.props.unlock_note.length > 0) {
            pharagraphs[this.props.global_operation].splice(1, 0, (<WrapperContentFromArticleForPopup note={this.props.unlock_note} />));
        }

        this.state = {
            stage: 1,
            pharagraphs: pharagraphs
        };
    }

    goNextStage() {
        addStepLog('Press button goNext, stage: '+this.state.stage+' on Thank you Page on '+this.props.global_operation+' operation');
        let stage = this.state.stage;
        if (stage < Object.keys(this.state.pharagraphs[this.props.global_operation]).length)
            this.setState({stage: ++stage})
    }
    goBackPrevStage() {
        addStepLog('Press button goBack, stage: '+this.state.stage+' on Thank you Page on '+this.props.global_operation+' operation');
        let stage = this.state.stage;
        if (stage > 1)
            this.setState({stage: --stage})
    }

    nextContinue() {
        addStepLog('Press button Go, stage: '+this.state.stage+' on Thank you Page on '+this.props.global_operation+' operation');
        this.props.nextContinue();
    }

    showContinueBtn() {
        return <button type="button"
                       className={'go-btn' + (this.props.global_operation === 'unlock' ? ' go-submit' : ' go-next')}
                       onClick={this.nextContinue.bind(this)}
        />
    }

    render() {
        let global_operation = this.props.global_operation;
        console.log(`global_operation: ${safeStringify(global_operation)}`);

        console.log(`this.state.pharagraphs: ${safeStringify(this.state.pharagraphs)}`);
        let phs = this.state.pharagraphs[global_operation];
        console.log(`phs: ${safeStringify(phs)}`);

        let stage = this.state.stage;
        let indStage = stage - 1;
        let countStages = Object.keys(phs).length;
        return (
            <div>
                <div className="p-3">
                    <div className="row">
                        <div className="col-12">
                            <h1 className="gray">{stage} of {countStages}</h1>
                        </div>
                    </div>
                    <div className={'row' +  ((global_operation === 'unlock' && countStages > 4 && stage === 2) ?  '' : ' text-center')}>
                        <div className="col-12 px-3">
                            {phs[indStage]}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="row text-center">
                                <div className="col-6">
                                    {
                                        stage !== 1 ?
                                            (
                                                <button type="button"
                                                        className="go-btn go-back"
                                                        onClick={this.goBackPrevStage.bind(this)}/>
                                            ) : ('')
                                    }
                                </div>
                                <div className="col-6">
                                    {
                                        stage < countStages ?
                                            (
                                                <button type="button"
                                                        className="go-btn go-next"
                                                        onClick={this.goNextStage.bind(this)}/>
                                            ) : (
                                                <>{this.showContinueBtn()}</>
                                            )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class ThankYouPage extends Component {
    constructor(props) {
        super(props);
        this.handleSetPage = this.handleSetPage.bind(this);
        this.sendSetCompletedUnlock = this.sendSetCompletedUnlock.bind(this);
        this.nextContinue = this.nextContinue.bind(this);
        this.state = {redirect: null};

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    handleSetPage(options) {
        this.props.handleSetPage(options);
    }

    nextContinue () {
        if (this.props.global_operation === 'unlock') {
            this.sendSetCompletedUnlock();
        } else {
            this.setState({redirect:'send_rate'});
            close_popup();
            // close_popup();
            // show_popup(<ReminderPopup handleSetPage={this.handleSetPage} reloadPage={()=>this.setState({redirect:'send_rate'})}/>, {auto_close: false});
        }
    }

    sendSetCompletedUnlock() {
        let t = this;
        let params = {
            session_key: t.props.session_key,
            global_operation: t.props.global_operation,
            action: 'api/booking/completed_unlock'
        };

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: showPreloader,
            func_callback: function (resp) {
                if (resp.success === 1) {
                    window.location.href = bm_base_path + '/welcome/';
                } else {
                    hidePreloader();
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(resp.errors.main);
                    }
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }

    componentDidMount() {
        show_popup(<ShowPopup nextContinue={this.nextContinue}
                              global_operation={this.props.global_operation}
                              unlock_note={this.props.unlock_note}
        />, {auto_close:false})
    }

    render() {
        if (this.state.redirect !== null){
            if(this.state.redirect === 'send_rate')
                addStepLog('Send rate Page');

            return <Redirect push to={"/" + this.state.redirect} />;
        }

        
        return (
			<div className={'value-space'} />
        );
    }
}

const ThankYouPageR = withRouter(ThankYouPage);
export default ThankYouPageR;
